import styled from 'styled-components';

export const Td = styled.td`
  color: var(--color);
  padding: 16px;
  font-family: 'GothamLight', Arial, Helvetica, sans-serif; ;
`;
